export default __webpack_public_path__ + "static/media/list-sep.5ce19368.svg";